var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", { ref: "validation" }, [
    _c(
      "div",
      { staticClass: "container-cadastro" },
      [
        _c("div", { staticClass: "card-header" }, [_vm._v("Resumo")]),
        !_vm.loading
          ? _c("pecaTecnica", {
              attrs: { cadastroColetivo: _vm.cadastroColetivo, isResumo: true },
              on: { validacaoDocumentos: _vm.documentos }
            })
          : _c("div", { staticClass: "load" }, [
              _c("h4", [_vm._v("Aguarde a geração de peças técnicas.")]),
              _c("img", {
                staticClass: "relogio",
                staticStyle: {},
                attrs: {
                  src: require("@/assets/images/relogio.gif"),
                  alt: "alt"
                }
              })
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b20c06b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b20c06b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gat/components/ResumoPecasTecnicas.vue
// module id = null
// module chunks = 